<template>
  <div>
    <Breadcrumb msg1="价格体系" msg2="价格体系" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-button type="success" icon="el-icon-plus" @click="addSys">新增价格体系</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-table :data="systems" border highlight-current-row @row-click="selectSys">
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="编码" prop="code" width="120"></el-table-column>
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click.stop="editSys(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click.stop="delSys(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="14">
          <div style="margin-bottom: 10px">
            <span style="margin-right: 10px">价格明细（{{ currentSys.name || '请选择左侧体系' }}）</span>
            <el-button size="mini" type="primary" :disabled="!currentSys.id" @click="openItemDialog">批量设置价格</el-button>
          </div>
          <el-table :data="priceItems" border size="small">
            <el-table-column label="类型" prop="itemType" width="100"></el-table-column>
            <el-table-column label="项目ID" prop="itemId" width="100"></el-table-column>
            <el-table-column label="价格" prop="price" width="120"></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="editPrice(scope.row)">改价</el-button>
                <el-button size="mini" type="danger" @click="delPrice(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>

    <el-dialog :title="sysDialogTitle" :visible.sync="sysShow" width="400px" :close-on-click-modal="false">
      <el-form :model="sysForm" label-width="80px">
        <el-form-item label="名称"><el-input v-model="sysForm.name"></el-input></el-form-item>
        <el-form-item label="编码"><el-input v-model="sysForm.code"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="sysShow = false">取消</el-button>
        <el-button type="primary" @click="saveSys">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量设置价格" :visible.sync="itemShow" width="700px">
      <el-table :data="itemRows" border size="small">
        <el-table-column label="类型" width="140">
          <template slot-scope="scope">
            <el-select v-model="scope.row.itemType" size="mini">
              <el-option label="商品" value="商品"></el-option>
              <el-option label="项目" value="项目"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="项目ID">
          <template slot-scope="scope"><el-input v-model.number="scope.row.itemId" size="mini"></el-input></template>
        </el-table-column>
        <el-table-column label="价格" width="140">
          <template slot-scope="scope"><el-input v-model.number="scope.row.price" size="mini"></el-input></template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="itemRows.splice(scope.$index, 1)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button size="mini" icon="el-icon-plus" style="margin-top: 8px" @click="itemRows.push({ itemType: '商品', itemId: null, price: 0 })">添加</el-button>
      <span slot="footer">
        <el-button @click="itemShow = false">取消</el-button>
        <el-button type="primary" @click="saveItems">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      systems: [],
      currentSys: {},
      priceItems: [],
      sysShow: false,
      sysDialogTitle: '',
      sysForm: {},
      itemShow: false,
      itemRows: []
    }
  },
  created () { this.getSystems() },
  methods: {
    getSystems () {
      this.$axios.http.get('/priceSystems').then(r => {
        if (r.data.status === 200) this.systems = r.data.data || []
      })
    },
    selectSys (row) {
      this.currentSys = row
      this.$axios.http.get('/priceItems', { params: { price_system_id: row.id } }).then(r => {
        if (r.data.status === 200) this.priceItems = r.data.data || []
      })
    },
    addSys () {
      this.sysDialogTitle = '新增价格体系'
      this.sysForm = { name: '', code: '' }
      this.sysShow = true
    },
    editSys (row) {
      this.sysDialogTitle = '编辑价格体系'
      this.sysForm = Object.assign({}, row)
      this.sysShow = true
    },
    saveSys () {
      if (this.sysForm.id) {
        this.$axios.put(`/priceSystems/${this.sysForm.id}`, () => { this.sysShow = false; this.getSystems() }, this.sysForm)
      } else {
        this.$axios.post('/priceSystems', () => { this.sysShow = false; this.getSystems() }, this.sysForm)
      }
    },
    delSys (row) {
      this.$axios.del(`/priceSystems/${row.id}`, () => this.getSystems())
    },
    openItemDialog () {
      this.itemRows = [{ itemType: '商品', itemId: null, price: 0 }]
      this.itemShow = true
    },
    saveItems () {
      this.$axios.post('/priceItems', () => {
        this.itemShow = false
        this.selectSys(this.currentSys)
      }, { price_system_id: this.currentSys.id, items: this.itemRows })
    },
    editPrice (row) {
      this.$prompt('新价格', '改价', { inputValue: row.price, inputPattern: /^\d+(\.\d{1,2})?$/, inputErrorMessage: '请输入数字' }).then(({ value }) => {
        this.$axios.put(`/priceItems/${row.id}`, () => this.selectSys(this.currentSys), { price: value })
      }).catch(() => {})
    },
    delPrice (row) {
      this.$axios.del(`/priceItems/${row.id}`, () => this.selectSys(this.currentSys))
    }
  }
}
</script>
